import { IconButton } from '@chakra-ui/react';
import { RiCloseLargeFill } from 'react-icons/ri';
import { Tooltip } from '@components/ui/tooltip';
import { useState } from 'react';
import ConfirmFinishCampaignDialog from './ConfirmFinishCampaignDialog';

type Props = {
  executionId: string,
  afterSubmit: () => void,
};

const FinishCampaignButton = ({ executionId, afterSubmit }: Props) => {
  const [showConfirmFinishCampaignDialog, setShowConfirmFinishCampaignDialog] = useState(false);
  
  return (
    <>
      <Tooltip content="Finalizar campanha" showArrow>
        <IconButton
          variant="ghost"
          color="red.500"
          onClick={() => setShowConfirmFinishCampaignDialog(true)}
        >
          <RiCloseLargeFill size={24} />
        </IconButton>
      </Tooltip>
      {showConfirmFinishCampaignDialog && (
        <ConfirmFinishCampaignDialog
          executionId={executionId}
          handleClose={() => setShowConfirmFinishCampaignDialog(false)}
          afterSubmit={afterSubmit}
        />
      )}
    </>
  )
};

export default FinishCampaignButton;
